import { useContext, useState } from "react";
import { createContext } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import { auth, db } from "../Services/Firebase";
import { doc, setDoc } from "firebase/firestore";
import { useEffect } from "react";

const AuthContext = createContext();

export function AuthContextProvider({ children }) {
  const [User, setUser] = useState({});

  useEffect(() => {
    let unsubscribe = onAuthStateChanged(
      auth,
      (User) => {
        setUser(User);
      },
      console.error
    );
    return () => unsubscribe(); //clean up when component is dismounted
  }, []);

  function SignUp(email, password) {
    createUserWithEmailAndPassword(auth, email, password);
    setDoc(doc(db, "users", email), {
      favShows: [],
    });
  }
  function LogIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function LogOut() {
    return signOut(auth);
  }

  return (
    <AuthContext.Provider value={{ User, SignUp, LogIn, LogOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function UserAuth() {
  return useContext(AuthContext);
}
